// extracted by mini-css-extract-plugin
export default {"columnSpace":"CalculationSettings_columnSpace__Gj--w"};